import { validatorReport } from "../../../companies/reports";
import { validatorReportExecution } from "../../../companies/reports/report_executions";
import { validatorPipelineTracking } from "../../../system/pipeline_tracking";
import { validatorUsers } from "../../../system/users";
import type { DomainGroup, TableScope } from "../types";

export const reportsDomain: DomainGroup = {
  id: "reports",
  name: "Reportes y Análisis",
  description: "Generación y análisis de reportes",
  icon: "BarChart",
  order: 7,
  status: "active",
  modules: [
    {
      id: "reports",
      name: "Reportes",
      description: "Crea, programa y ejecuta reportes personalizados",
      icon: "BarChart3",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/reports"],
      navigation: {
        showInNav: true,
        contexts: ["main"],
        navOrder: 7,
        status: "active",
      },
      tables: [
        {
          tableName: "reports",
          schema: validatorReport,
          scope: "branch" as TableScope,
          relations: [
            {
              key: "lastUpdatedBy",
              sourceField: "internalControl.updatedBy",
              schema: validatorUsers,
              tableName: "users",
            },
          ],
          searchFields: ["title", "description"],
          hasStatusIndex: true,
          searchIndex: { name: "search_reports", field: "title" },
        },
        {
          tableName: "report_executions",
          schema: validatorReportExecution,
          scope: "company" as TableScope,
          relations: [
            { key: "report", schema: validatorReport, tableName: "reports" },
            { key: "user", schema: validatorUsers, tableName: "users" },
          ],
          searchFields: ["status"],
          hasStatusIndex: false,
        },
      ],
      readOnlyTables: [
        { tableName: "clients" },
        { tableName: "branches" },
        { tableName: "companies" },
      ],
    },
    {
      id: "pipeline_tracking",
      name: "Seguimiento de Procesos",
      description: "Monitoreo de pipelines y procesos",
      icon: "Workflow",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/reports/pipelines"],
      navigation: {
        showInNav: false,
        contexts: ["none"],
        navOrder: 999,
        status: "active",
      },
      tables: [
        {
          tableName: "pipeline_tracking",
          schema: validatorPipelineTracking,
          scope: "company" as TableScope,
          relations: [
            { key: "user", schema: validatorUsers, tableName: "users" },
          ],
          searchFields: ["entityType", "entityId", "stage"],
          hasStatusIndex: true,
        },
      ],
      readOnlyTables: [{ tableName: "branches" }],
    },
  ],
};
